<template>
<div style="height:100%">
    <div class="infinite-loading-containers" v-if="isLoading">
        <i class="loading-defaults" ></i>
    </div>
	<div class="lmy-promote" ref="canvasView" id="canvasBox" v-show="!isLoading && !canvasViewShow">
        <div class="promote-nav">
            <div class="portrait">
                 <div class="avatar">
                    <img v-if="Avatar" class="myImg" :src="'data:image/jpeg;base64,'+Avatar"  crossOrigin = "anonymous">
                    <img v-else src="./../../assets/img/myqrLogo.png"  crossOrigin = "anonymous">

                </div>
                <div class="username">
                    <p>{{userInfo.Customer}}</p>
                    <p class="text">给您推荐了一个好东西</p>
                </div>
            </div>
            <img  :src="'data:image/jpeg;base64,'+qrbg"    crossOrigin = "anonymous">
        </div>
        <div class="promote-text">
            <div class="promote-money" v-if="price&&price>0">
                <p>
                    <span class="one">￥<span class="price">{{price}}</span>起</span> 
                    <span class="sale">特惠价</span>
                </p>
                <!-- <p>
                    <span  class="promote-money-price">
                        市场价
                        ￥{{details.MarketPrice}}
                        <div class="promote-money-hr"></div>
                    </span>
                </p> -->
            </div>
            <div class="promote-sum">
                <div class="name">
                    <p>{{details.Name}}</p>
                </div>
                <div class="code">
                    <img :src="'data:image/jpeg;base64,'+qr"  alt="" >
                </div>
            </div>
        </div>
        <div class="bottom-txt-box">
            <p class="bottom-txt">长按图片发给朋友或保存本地发朋友圈</p>
            <!-- <p class="bottom-txt">产生预定即可获得佣金</p> -->
        </div>

    </div>

    <div  v-if="canvasViewShow" class="promote-cancel">
        <div class="lmy-promote-cancel" onclick="window.history.go(-1)">
            <i class="iconfont icon-close"></i>
        </div>
        <img class="lmy-promote-img" :src="canvasViewImg"/>
    </div>


</div>

</template>

<script>
    import html2canvas from 'html2canvas';
	export default{
		name:'activity-promote',
		data(){
			return{
                userInfo:this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'',
                canvasViewImg:'',
                qr:'',
                qrbg:'',
				Avatar:'',
				canvasViewShow:false,
                details: JSON.parse(this.dao.get('packageDetails')),
                price:this.$route.query.price,
                isLoading:true

			}
		},
		methods:{

            initData(){
                var that=this;
                var params={
                    id:this.$route.query.id,
                }
                that.getRequest({
                    url: that.Api.getPackageMedia,
                    params:params
                }).then(res => {
                    if (res) {
                        that.Avatar=res.Result.Avatar;
                        that.qrbg=res.Result.Bg;
                        that.qr=res.Result.QR;
                        that.isLoading=false
                        that.$nextTick(() => {
                           that.initImg() 
                        })
                        
                    }
                    else{
                        that.isLoading=false
                        that.error({title:'提示',content:res.Msg});
                        window.history.go(-1)
                        
                    }
                });
            },

            initImg(){
                const el = this.$refs.canvasView;
                var that=this;
                setTimeout(()=>{
                    html2canvas(el,{useCORS: true}).then(function(canvas) { 
                        that.canvasViewImg= canvas.toDataURL();
                        that.canvasViewShow=true;
                    });
                },300)

            },
		},
		mounted(){
			this.initData();
		}
	}

</script>


// WEBPACK FOOTER //
// src/components/free/promote.vue